<template>
    <div class="collection-point-design-container">
        <me-collapes :treeTitle="'采集点选择'">
        
                <me-tree
                    ref="myTree"
                    :defaultProps="defaultProps"
                    :treeData="treeList"
                    :nodeKey="'point_id'"
                    :isSingle="true"
                    :showCheckbox="true"
                    :isCheckClick="true"
                    :checkStrictly="true"
                    :title="'采集点选择'"
                    :treeLoading="treeLoading"
                    :defaultCheckKeys="defaultCheckKeys"
                    :defaultExpandedKeys="expandedKeys"
                    :treeToolBar="false"
                    :showStretch="true"
                    @handleCheckBoxClick="handleTreeNodeClick"
                    @handleStretchClick="handleStretchClick"
                ></me-tree>
            
        </me-collapes>
        <div :style="`width:calc(100% - ${treeOuterWidth}px - 30px - 20px)`">
            <!-- 列表搜索过滤 -->
            <div class="form leader-style-form">
                <el-row :gutter="24">
                    <div style="margin-top: 10px;">
                        <el-button
                            class="search-wrap"
                            type="primary"
                            @click="handleEditInfo({}, '新增')"
                            size="medium"
                        >新增</el-button>
                    </div>
                </el-row>
            </div>
            <!-- 列表 -->
            <div class="table-wrap">
                <el-table
                    border
                    :data="tableList"
                    highlight-current-row
                    class="leader-style-table"
                    :header-cell-style="{
                        'background-color': '#f2f2f2',
                        color: '#909399',
                        'font-weight': 'bold'
                    }"
                    style="width: 100%;margin-top: 20px"
                >
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    (pageNum - 1) * pageSize + scope.$index + 1
                                }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="采集点名称" property="point_name" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" width="210">
                        <template slot-scope="scope">
                            <div class="color-blue">
                                <el-button
                                    type="text"
                                    class="button-delete"
                                    @click="hanleDelInfo(scope.row)"
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 新增、修改、查看 -->
            <el-dialog
                :title="dialogTitle" 
                width="650px" 
                :visible.sync="dialogStatus"
                @close="closeDiaCb"
                :close-on-click-modal="dialogTitle !== '查看' ? false : true"
                class="leader-dialog"
            >
                <div class="plan-dialog-wrap">
                    <div class="battery_search_btn">
                        <el-form
                            :model="searchForm"
                            class="leader-style-form"
                            style="padding: 0 40px;"
                            label-width="80"
                            :inline="true"
                        >
                            <el-form-item label="名称">
                                <el-input v-model="searchForm.point_name" maxlength="20" clearable></el-input>
                            </el-form-item>
                            <el-form-item style="float: right">
                                <el-button @click="getPointsList()">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <el-form
                        :model="userDetail"
                        ref="userDetail"
                        label-width="120px"
                        :rules="userDetailRule"
                        class="leader-style-form"
                    >
                        <el-form-item class="region-list-style" label-width="0px" 
                                     v-loading="loading"
                                    element-loading-text="拼命加载中"
                                    element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(0, 0, 0, 0.8)">
                            <el-checkbox-group v-model="checkedCities">
                                <el-checkbox 
                                    v-for="city in cities"
                                    :label="city.point_id"
                                    :key="city.point_id"
                                    class="region-list-item"
                                    :title="city.point_name"
                                    >
                                <span>
                                    {{ city.point_name.length > 10 ? city.point_name.substring(0, 10) + '...' : city.point_name }}
                                </span>
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <!-- <el-checkbox-group v-model="checkedCities">
                            <el-checkbox
                            style="width:25%"
                                v-for="city in cities"
                                :label="city.point_id"
                                :key="city.point_id"
                            >{{ city.point_name }}</el-checkbox>
                        </el-checkbox-group> -->
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button
                        @click="dialogStatus = false"
                        size="small"
                        class="leader-common-button"
                    >取消</el-button>
                    <el-button
                        v-if="dialogTitle !== '查看'"
                        @click="saveUserInfo"
                        type="primary"
                        size="small"
                        class="leader-common-button"
                    >保存</el-button> 
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/api-zmy.js";
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import util from "@/utils/util";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    data() {
        return {
            searchForm: {
                point_name: ''
            },
            treeOuterWidth: 280,
            treeList: [],
            tableList: [],
            expandedKeys: [], //默认展开节点
            point_id: "",
            elec_customer_id: "",
            treeLoading: false,
            treeSelect: {},
            dialogTitle: "新增", //弹窗title
            dialogStatus: false, //弹窗关闭状态
            checkedCities: [],
            cities: [],
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            loading: false,
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0 //总条数
        };
    },
    created() {
        this.getPointTree();
    },
    methods: {
        
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth;
        },
        /**
         * 点击新增、查看、修改按钮：
         * params {row<object>} 行数据
         * params {type<string>} 类型：type 新增，查看，删除
         */
        handleEditInfo(row, type) {  
            this.checkedCities = [];
            this.dialogTitle = type;
            this.dialogStatus = true; 
            // this.loading=true;
            this.getPointsList();    
        },
        getPointTree() {
            this.treeLoading = true;
            api.getPointTree().then(res => {
                if (res && res.error_code === "0") {
                    this.treeList = res.bus_json;
                    this.tickMenuIdFilter().filter(this.treeList);
                    let firstPoint = this.tickMenuIdFilter().getFirst(
                        this.treeList
                    );
                    this.point_id = firstPoint.point_id;
                    this.elec_customer_id = firstPoint.elec_customer_id;
                    this.expandedKeys = [firstPoint.point_id];
                    this.$refs.myTree.handleCheckBoxClick(firstPoint);
                    this.getimaginaryPointList();
                }
                this.treeLoading = false;
            });
        },

        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.collector_id) {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.point_id);
                } else {
                    obj.disabled = false;
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return resultArr;
                },
                // 获取第一个实采集点
                getFirst: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return firstPoint;
                }
            };
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = [select.point_id];
            // 实采集点
            this.point_id = select.point_id;
            this.elec_customer_id = select.elec_customer_id;
            this.getimaginaryPointList();
        },

        /**
         * 获取虚点列表
         */
        getimaginaryPointList() {
            api.getimaginaryPointList({
                point_id: this.point_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableList = res.bus_json.items;
                }
            });
        },
        /**
         * 获取虚点可选列表
         */
        getPointsList() {    
            this.loading=true;
            api.getPointsList({
                ...this.searchForm,
                elec_customer_id: this.elec_customer_id,
                point_id: this.point_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.cities = res.bus_json;
                }
                 this.loading=false;
            }); 
            
        },
        /**
         * 保存虚点可选列表
         */
        saveUserInfo: util.debounce(function(row)  {
            if (this.checkedCities.length > 0) {
                const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.1)"
                });
                const point_ids = this.checkedCities.join(";");

                console.log(point_ids);

                api.getimaginaryPointSave({
                    point_id: this.point_id,
                    point_ids: point_ids
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.$message({
                            type: "success",
                            message: res.error_msg
                        });
                        this.getimaginaryPointList();
                        this.dialogStatus = false;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.error_msg
                        });
                    }
                    loading.close();
                });
            } else {
                this.$message({
                    type: "warning",
                    message: "请选择采集点"
                });
            }
              
        }),
        /**
         * 删除虚点可选列表
         */
        hanleDelInfo(row) {
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "保存",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.getimaginaryPointdel({
                        point_uninstall_id: row.point_uninstall_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getimaginaryPointList();
                        }
                    });
                })
                .catch(() => { });
        }
    }
};
</script>
<style lang="scss" scoped>
.el-loading-mask{background-color: rgba(255, 255, 255, .1)!important}
.collection-point-design-container {
    .collapes-block-container {
        width: auto !important;
    }
    width: 100%;
    height: 100%;
    display: flex;
    padding: 0 px2Rem(20px);
    box-sizing: border-box;
    flex-direction: row;

    .tree-container {
        width: px2Rem(280px);
        height: 100%;
        overflow: hidden;
        border-right: 1px solid #b1c7dd;
        padding-right: 20px;
        box-sizing: border-box;
    }
    .search-wrap {
        float: right;
        margin-right: 13px;
    }

    /*.tree-form-wrap {*/
    /*  width: calc(100% - 280px);*/
    /*}*/

}
</style>

<style scoped>
.region-list-style /deep/ .el-checkbox + .el-checkbox {
    margin-left: 0px;
}
.region-list-style /deep/ .el-checkbox {
    margin-right: 3.3%;
}
/* 用来调整每一项的宽度 */
.region-list-item {
    width: 30%;
    white-space: nowrap;
    /* text-overflow: ellipsis; */
    overflow: hidden;
}
</style>
